<template>
	<div>
		<div id="mstar-ownership-body">
			<h3 class="module-title">
				Morningstar Ownership Zone
				<disclosure-superscript class="detail-page" anchor="msOwnerShip"
					:statistics="['morningstarOwnership']" />
			</h3>
			<div class="row mstar-zone-content">
				<div class="col-xs-5 col-sm-4 col-md-4">
					<div class="row strong visible-sm visible-xs">
						<div class="adjust-up">
							<div class="col-md-12">
								{{ mstarCategory }}
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="investment-box-container investment_Style_Labelspng">
								<img :src="chartImage" class="morningstar-investment-box">
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-7 col-sm-8 col-md-8">
					<div class="ownership-legend">
						<div class="row strong visible-lg visible-md">
							<div class="col-lg-12">
								{{ mstarCategory }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="weighted-legend-circle" /> <span class="detail-label">Weighted average of
									holdings</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="stock-holdings-legend-circle" /> <span class="detail-label">75% of fund's
									stock
									holdings</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="as-of-date">
									<div class="legend-circle" />
									<span>
										<span>Morningstar data as</span>
										{{ portfolioDate }}
										<span>(updated quarterly)</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<a class="label-with-icon" :href="`${insightUrl}`">
						<i class="link-arrow" />
						<span>INSIGHTS ON THE MORNINGSTAR OWNERSHIP ZONE</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'MStarOwnership',
	computed: {
		...mapGetters(['mstarOwnershipData', 'getAudience', 'getBaseUrl']),
		insightUrl() {
			let url = null;
			const audience = this.getAudience && this.getAudience.toLowerCase();

			if (audience === 'institutional') {
				url = `${this.getBaseUrl}/us/investments/morningstar-tools.html`;
			} else if (audience === 'individual' || audience === 'advisor') {
				url = `${this.getBaseUrl}/${audience}/investments/morningstar-tools.html`;
			}
			return url;
		},
		ownershipData() {
			const returnObj = this.mstarOwnershipData;
			return returnObj;
		},
		chartImage() {
			return this.mstarOwnershipData && this.mstarOwnershipData.ChartImage || '';
		},
		mstarCategory() {
			return this.mstarOwnershipData && this.mstarOwnershipData.MstarCategory || '';
		},
		portfolioDate() {
			return this.mstarOwnershipData && this.mstarOwnershipData.PortfolioDate || '';
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/variables';

#mstar-ownership-body {
	.as-of-date {
		font-size: 12px;
		font-family: "AvenirNextLTW01-Condens 721299", Arial;
		color: @gray;
		margin-top: 15px;
	}

	.adjust-up {
		margin-bottom: 10px;
	}

	.module-border-top();
	margin-bottom: 35px;

	.style-box-title {
		padding-left: 13px;
	}

	.morningstar-investment-box {
		width: 80px;
		height: 80px;
		border-bottom: 1px solid #555;
		border-right: 1px solid #555;
	}

	.mstar-zone-content {
		margin-top: 10px;
		margin-bottom: 13px
	}

	.mstar-zone-img {
		border-bottom: 1px solid #555;
		border-right: 1px solid #555;
	}

	.weighted-legend-circle {
		.legend-circle;
		background-color: #C4161C
	}

	.label-with-icon {
		font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
		padding-right: 14px;
		display: flex;
		overflow: hidden;

		a {
			font-family: "AvenirNextLTW01-DemiCn", Arial, sans-serif;
			font-size: 12px;
			color: #1d5799;
			text-decoration: none;
			overflow: hidden;
			display: block;

			span {
				color: #009adf;
				white-space: nowrap;
			}
		}
	}

	.stock-holdings-legend-circle {
		.legend-circle;
		background-color: #e2dfbc;
		margin-top: 10px;
	}

	.legend-circle {
		width: 8px;
		height: 8px;
		-webkit-border-radius: 5px;
		-mox-border-radius: 5px;
		border-radius: 5px;
		display: inline-block;
	}

	.detail-label {
		font-size: 12px;
		font-family: AvenirNextLTW01-Regular, Arial;
		color: @gray;
		padding-left: 3px;
	}

	.investment_Style_Labelspng {
		display: inline-block;
		width: 117px;
		height: 114px;
		background-repeat: no-repeat;
		background-position: top left;
		background-image: url(data:image/png;base64,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);
	}

	@media (max-width: 768px) {
		.ownership-legend {
			padding-top: 20px;
		}
	}
}
</style>